export default "__VITE_ASSET__98caf81f__"